import { render, staticRenderFns } from "./Portada.vue?vue&type=template&id=6dcd5758"
var script = {}
import style0 from "./Portada.vue?vue&type=style&index=0&id=6dcd5758&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports